import { gql } from "@apollo/client";

const LINK_USERS = gql`
  mutation LinkUsers($token: String!, $userLoginId: String!) {
    linkUsers(token: $token, userLoginId: $userLoginId) {
      _id
      createdAt
      expectedEmail
      expectedFirstName
      expectedLastName
      inviteConfirmationToken
      inviteExpirationDate
      inviteStatus
      inviteType
      linkedDocumentId {
        entityName
      }
      linkedField
      roles
      senderId
      type
      updatedAt
    }
  }
`;

const UPDATE_LINK_USERS_INVITE = gql`
  mutation UpdateLinkUsersInvite($args: UserInviteInput!, $inviteId: String!) {
    updateLinkUsersInvite(args: $args, inviteId: $inviteId) {
      _id
      createdAt
      expectedEmail
      expectedFirstName
      expectedLastName
      inviteConfirmationToken
      inviteExpirationDate
      inviteStatus
      inviteType
      linkedDocumentId {
        entityName
      }
      linkedField
      roles
      senderId
      type
      updatedAt
    }
  }
`;

const LINK_USER_TO_DOCUMENT = gql`
  mutation LinkUserToDocument($token: String!, $userLoginId: String!) {
    linkUserToDocument(token: $token, userLoginId: $userLoginId) {
      _id
      expectedEmail
      expectedFirstName
      expectedLastName
      inviteConfirmationToken
      inviteExpirationDate
      inviteStatus
      inviteType
      senderId
    }
  }
`;

const ACKNOWLEDGE_INVITE = gql`
mutation AcknowledgeInvite($userInviteId: String!) {
  acknowledgeInvite(userInviteId: $userInviteId) {
    _id
    meta {
      notified
    }
  }
}
`;

const CANCEL_INVITE = gql`
  mutation CancelInvite($inviteId: String!, $roles: [String]) {
    cancelInvite(inviteId: $inviteId, roles: $roles) {
      _id
      createdAt
      expectedEmail
      expectedFirstName
      expectedLastName
      inviteConfirmationToken
      inviteExpirationDate
      inviteStatus
      inviteType
      linkedDocumentId {
        entityName
      }
      linkedField
      roles
      senderId
      type
      updatedAt
    }
  }
`;

export { LINK_USERS, UPDATE_LINK_USERS_INVITE, LINK_USER_TO_DOCUMENT, CANCEL_INVITE, ACKNOWLEDGE_INVITE };
